
/*
 * GLOBAL THEME READY
 */
$(window).ready(function() {

    aosInit();
    onElementHeightChange(document.body, function(){
        AOS.refresh();
    });

    loadPages();
});


/*
 * GLOBAL THEME WINDOW RESIZE
 */
$(window).resize(function() {
    AOS.refresh();
});

function loadPages() {
    var load = $(".load-page");
    load.fadeOut(400);
}



